/* eslint-disable */
// src/layouts/security/index.js

import React, { useState } from "react";
import Card from "@mui/material/Card";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AuthorizedDevicesPanel from "layouts/security/AuthorizedDevicesPanel";
import RefreshSessionsPanel from "layouts/security/RefreshSessionsPanel";

export default function Security() {
  const [tab, setTab] = useState(0);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Card sx={{ overflow: "visible" }}>
          <MDBox
            mx={{ xs: 1.5, sm: 2 }}
            mt={-3}
            py={{ xs: 2, sm: 2.5 }}
            px={{ xs: 2, sm: 3 }}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Seguridad
            </MDTypography>
          </MDBox>

          <MDBox px={{ xs: 1.5, sm: 3 }} pt={{ xs: 2, sm: 3 }} pb={3}>
            <Tabs
              value={tab}
              onChange={(event, value) => setTab(value)}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              aria-label="Secciones de seguridad"
              sx={({ palette }) => ({
                mb: 3,
                borderBottom: "1px solid",
                borderColor: "divider",
                minHeight: 48,
                backgroundColor: palette.mode === "dark" ? "#4B5563" : "#D1D5DB",
                "& .MuiTabs-indicator": { backgroundColor: "#fff" },
                "& .MuiTab-root": {
                  color: `${palette.mode === "dark" ? "#fff" : "#374151"} !important`,
                },
                "& .MuiTab-root.Mui-selected": { color: "#1F2937 !important" },
              })}
            >
              <Tab label="Dispositivos" sx={{ minHeight: 48, fontWeight: 700 }} />
              <Tab label="Sesiones" sx={{ minHeight: 48, fontWeight: 700 }} />
            </Tabs>
            {tab === 0 && <AuthorizedDevicesPanel />}
            {tab === 1 && <RefreshSessionsPanel />}
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
